import React from "react";
import { Alert, Checkbox, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { dashboardViewOptions } from "../data/dashboardViews";

const DashboardAccessEditor = ({ dashboards, roleName, setFieldValue }) => {
  const { t } = useTranslation();
  const selectedDashboards = dashboards ?? [];

  const showConsultantHint =
    /consultant/i.test(roleName) &&
    selectedDashboards.includes("DM") &&
    !selectedDashboards.includes("DC");

  return (
    <Stack spacing="md">
      <Text size="sm" color="dimmed">
        {t(
          "Select which dashboard tabs users with this role can see on the Dashboard page."
        )}
      </Text>

      <Checkbox.Group
        value={selectedDashboards}
        onChange={(value) => setFieldValue("dashboards", value)}
      >
        <Stack spacing="sm">
          {dashboardViewOptions.map((view) => (
            <Checkbox
              key={view.id}
              value={view.id}
              label={
                <div>
                  <Text size="sm" weight={500}>
                    {t(view.label)} ({view.id})
                  </Text>
                  <Text size="xs" color="dimmed">
                    {t(view.descriptionKey)}
                  </Text>
                </div>
              }
            />
          ))}
        </Stack>
      </Checkbox.Group>

      {showConsultantHint && (
        <Alert color="yellow" title={t("Consultant role hint")}>
          {t(
            "Consultant roles typically need Consultant View (DC). Management View (DM) shows company-wide data."
          )}
        </Alert>
      )}

      <Text size="xs" color="dimmed">
        {t(
          "Users must log in again for dashboard view changes to apply."
        )}
      </Text>
    </Stack>
  );
};

export default React.memo(
  DashboardAccessEditor,
  (prev, next) =>
    prev.dashboards === next.dashboards &&
    prev.roleName === next.roleName &&
    prev.setFieldValue === next.setFieldValue
);
